import{createUseStyles as o}from"react-jss";var r=o((o=>({popover:{},modalBody:{}})));export{r as default};
